/**
 * filters.js — bộ lọc + sắp xếp của trang Cửa hàng / danh mục (mục 18 · 33).
 *
 * Markup cần (archive-product.html, taxonomy-product_cat.html):
 *   aside.filter-drawer[data-filters] > [data-filter-close] (overlay) + form[data-filter-form]
 *     .filter-group[data-filter="country"][data-filter-field="country"][data-filter-limit="4"]
 *         label.filter-option > input[type=checkbox][data-match="Pháp"] … [data-option-count]
 *         button.filter-more[data-filter-more="quốc gia"] > [data-filter-more-label]
 *     .price-range[data-price-range] > input[type=range][data-range=lo|hi] + input[data-range-text=lo|hi]
 *     .filter-group[data-filter="rating"] input[type=radio][value="4.5"]
 *     .filter-group__toggle[aria-expanded][aria-controls] · button[data-filter-submit]
 *   [data-filter-open] (nút "Bộ lọc" mobile) > [data-filter-badge] · [data-filter-clear] (mọi nút xoá)
 *   [data-filter-results] > [data-filter-result] (số kết quả) · [data-filter-chips] > [data-filter-active]
 *     + button[data-filter-quick] · [data-filter-grid][data-total] > .product-card[data-product-id]
 *     · [data-filter-empty] · [data-load-more] · select[data-filter-sort]
 *
 * Bản tĩnh LỌC THẬT trên các card đang có trong lưới: đọc data-product-id của từng card,
 * tra window.WBCatalog.get(id) (type, country, grape, price, rating) rồi ẩn/hiện card.
 * Số cạnh mỗi lựa chọn đếm kiểu "facet" như layered nav của WooCommerce: áp mọi nhóm KHÁC
 * đang chọn rồi đếm — nên tick "Pháp" không làm số của "Ý" về 0 (trong cùng nhóm là HOẶC,
 * giữa các nhóm là VÀ). Lựa chọn 0 kết quả bị ẩn (quy tắc mục 18), trừ khi đang được chọn.
 *
 * Trạng thái lọc đọc thẳng từ form mỗi lần vẽ chứ không giữ object riêng: form là nguồn sự
 * thật duy nhất, nên trình duyệt tự khôi phục ô đã tick khi bấm Back cũng hiển thị đúng.
 *
 * Mặc định KHÔNG lọc gì (lưới đủ card) dù ảnh guideline vẽ sẵn "Pháp" + "Dưới 2 triệu":
 * lọc sẵn thì trang danh mục mẫu chỉ còn 1 chai. Hai tag đó nằm ở hàng gợi ý nhanh.
 *
 * Khởi tạo trong DOMContentLoaded vì gulp gộp module theo thứ tự chữ cái — catalog.js và
 * store.js (WBStore.money) có thể chưa chạy khi file này được đọc.
 *
 * Drawer mobile (mở / đóng / khoá cuộn / Esc / giữ focus) nằm riêng ở shop-filter-drawer.js.
 *
 * WP/WooCommerce: lọc là việc của server — form GET gửi min_price/max_price, filter_*,
 * orderby (WC_Query đọc sẵn) hoặc AJAX thay lưới. Khi đó bỏ apply()/sortCards() trên DOM,
 * chỉ giữ phần giao diện: thu gọn nhóm, "Xem thêm", thanh trượt giá, chip × (bỏ
 * chọn rồi submit), "Xóa tất cả" (về link term / trang Shop).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    function all(selector, scope) {
        return [].slice.call((scope || document).querySelectorAll(selector));
    }

    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    function money(value) {
        if (window.WBStore) return window.WBStore.money(value);
        return Math.round(Number(value) || 0).toLocaleString('vi-VN') + '₫';
    }

    // Nhãn tag giá cho gọn: 2000000 → "2 triệu", 1500000 → "1,5 triệu", 500000 → "500 nghìn"
    function shortMoney(value) {
        if (value >= 1000000) return String(Math.round(value / 100000) / 10).replace('.', ',') + ' triệu';
        if (value >= 1000) return Math.round(value / 1000) + ' nghìn';
        return money(value);
    }

    function digits(text) {
        return parseInt(String(text).replace(/\D/g, ''), 10);
    }

    // Phần tử bị ẩn (hoặc nằm trong khối bị ẩn) thì không nhận focus được
    function isShown(el) {
        return !!el && (el.offsetWidth > 0 || el.offsetHeight > 0);
    }

    function init() {
        var root = document.querySelector('[data-filters]');
        var form = root ? root.querySelector('[data-filter-form]') : null;
        var grid = document.querySelector('[data-filter-grid]');
        if (!form || !grid) return;

        var resultEl = document.querySelector('[data-filter-result]');
        var chipsRow = document.querySelector('[data-filter-chips]');
        var activeBox = chipsRow ? chipsRow.querySelector('[data-filter-active]') : null;
        var quickChips = chipsRow ? all('[data-filter-quick]', chipsRow) : [];
        var chipsClear = chipsRow ? chipsRow.querySelector('[data-filter-clear]') : null;
        var empty = document.querySelector('[data-filter-empty]');
        var loadMore = document.querySelector('[data-load-more]');
        var sortSelect = document.querySelector('[data-filter-sort]');
        var submit = form.querySelector('[data-filter-submit]');
        var openers = all('[data-filter-open]');
        var badge = document.querySelector('[data-filter-badge]');

        // ----- Nhóm checkbox -----
        var groups = all('[data-filter-field]', form).map(function (el) {
            var more = el.querySelector('[data-filter-more]');
            return {
                key: el.getAttribute('data-filter'),
                field: el.getAttribute('data-filter-field'),
                limit: parseInt(el.getAttribute('data-filter-limit'), 10) || 0,
                more: more,
                moreLabel: more ? more.querySelector('[data-filter-more-label]') : null,
                noun: more ? more.getAttribute('data-filter-more') : '',
                body: el.querySelector('.filter-group__body'),
                none: null,
                expanded: false,
                options: all('.filter-option', el).map(function (label) {
                    var input = label.querySelector('input');
                    var name = label.querySelector('.filter-option__label');
                    return {
                        label: label,
                        input: input,
                        match: input.getAttribute('data-match'),
                        name: name ? name.textContent.trim() : input.value,
                        countEl: label.querySelector('[data-option-count]'),
                        count: 0
                    };
                })
            };
        });

        var optionById = {};
        groups.forEach(function (g) {
            g.options.forEach(function (o) {
                if (o.input.id) optionById[o.input.id] = o;
            });
        });

        var ratings = all('[data-filter="rating"] input[type="radio"]', form);

        // ----- Khoảng giá -----
        var range = form.querySelector('[data-price-range]');
        var lo = range ? range.querySelector('[data-range="lo"]') : null;
        var hi = range ? range.querySelector('[data-range="hi"]') : null;
        var loText = range ? range.querySelector('[data-range-text="lo"]') : null;
        var hiText = range ? range.querySelector('[data-range-text="hi"]') : null;
        var MIN = lo ? Number(lo.min) : 0;
        var MAX = lo ? Number(lo.max) : Infinity;
        var STEP = lo ? Number(lo.step) || 1 : 1;

        function priceLabel(a, b) {
            if (a <= MIN) return 'Dưới ' + shortMoney(b);
            if (b >= MAX) return 'Từ ' + shortMoney(a);
            return shortMoney(a) + ' – ' + shortMoney(b);
        }

        function setRange(a, b) {
            if (!lo) return;
            // Hai input range độc lập, trình duyệt không tự giữ thứ tự — tự ép "từ" < "đến"
            // ít nhất một bước, không thì hai nút chồng khít lên nhau và không kéo ra được
            hi.value = Math.max(b, a + STEP);
            lo.value = Math.min(a, Number(hi.value) - STEP);
            paintRange();
        }

        function paintRange() {
            if (!lo) return;
            var a = Number(lo.value);
            var b = Number(hi.value);
            range.style.setProperty('--lo', (a - MIN) / (MAX - MIN));
            range.style.setProperty('--hi', (b - MIN) / (MAX - MIN));
            lo.setAttribute('aria-valuetext', money(a));
            hi.setAttribute('aria-valuetext', money(b));
            // Không ghi đè ô người dùng đang gõ dở
            if (document.activeElement !== loText) loText.value = money(a);
            if (document.activeElement !== hiText) hiText.value = money(b);
        }

        // Ô số: gõ tự do, tới lúc rời ô / Enter mới đọc số, kẹp trong biên và đẩy về thanh trượt
        function commitText(which) {
            if (!lo) return;
            var field = which === 'lo' ? loText : hiText;
            var value = digits(field.value);
            if (isNaN(value)) value = which === 'lo' ? MIN : MAX;
            value = Math.max(MIN, Math.min(MAX, value));
            if (which === 'lo') lo.value = Math.min(value, Number(hi.value) - STEP);
            else hi.value = Math.max(value, Number(lo.value) + STEP);
            field.value = money(which === 'lo' ? lo.value : hi.value);
            paintRange();
        }

        // ----- Card trong lưới -----
        function cards() {
            return all('.product-card', grid);
        }

        function productOf(card) {
            return window.WBCatalog ? window.WBCatalog.get(card.getAttribute('data-product-id')) : null;
        }

        // Số thứ tự gốc = thứ tự server trả về ("Bán chạy nhất"); card mới nạp thêm nối tiếp
        function indexCards() {
            var next = 0;
            var list = cards();
            list.forEach(function (card) {
                var v = card.getAttribute('data-shop-index');
                if (v !== null) next = Math.max(next, Number(v) + 1);
            });
            list.forEach(function (card) {
                if (!card.hasAttribute('data-shop-index')) card.setAttribute('data-shop-index', next++);
            });
        }

        // ----- Trạng thái lọc (đọc từ form) -----
        function readState() {
            var state = { lists: {}, lo: lo ? Number(lo.value) : MIN, hi: hi ? Number(hi.value) : MAX, rating: 0 };
            groups.forEach(function (g) {
                state.lists[g.key] = g.options.filter(function (o) {
                    return o.input.checked;
                }).map(function (o) {
                    return o.match;
                });
            });
            ratings.forEach(function (r) {
                if (r.checked) state.rating = Number(r.value);
            });
            return state;
        }

        // skip: tên nhóm bỏ qua khi đếm facet cho chính nhóm đó
        function matches(p, state, skip) {
            // Card không có trong catalog mẫu thì không biết thuộc tính — cứ hiện, đừng làm mất hàng
            if (!p) return true;
            for (var i = 0; i < groups.length; i++) {
                var g = groups[i];
                var list = state.lists[g.key];
                if (g.key !== skip && list.length && list.indexOf(String(p[g.field])) === -1) return false;
            }
            if (skip !== 'price' && (p.price < state.lo || p.price > state.hi)) return false;
            if (skip !== 'rating' && state.rating && p.rating < state.rating) return false;
            return true;
        }

        function activeFilters(state) {
            var list = [];
            groups.forEach(function (g) {
                g.options.forEach(function (o) {
                    if (o.input.checked) list.push({ id: o.input.id, label: o.name });
                });
            });
            if (state.lo > MIN || state.hi < MAX) list.push({ id: 'price', label: priceLabel(state.lo, state.hi) });
            ratings.forEach(function (r) {
                if (r.checked) list.push({ id: r.id, label: 'Từ ' + r.value + ' sao' });
            });
            return list;
        }

        // ----- Ẩn lựa chọn 0 kết quả + "Xem thêm N …" -----
        function layoutGroup(g) {
            var shown = 0;
            var extra = 0;
            var available = 0;

            g.options.forEach(function (o) {
                // Lựa chọn đang tick hoặc đang giữ focus không bao giờ biến mất dưới tay người dùng
                var keep = o.input.checked || o.input === document.activeElement;
                if (!keep && o.count === 0) {
                    o.label.hidden = true;
                    return;
                }
                available++;
                if (g.limit && !g.expanded && shown >= g.limit && !keep) {
                    o.label.hidden = true;
                    extra++;
                    return;
                }
                o.label.hidden = false;
                shown++;
            });

            // Mọi lựa chọn đều về 0 (vd. đang lọc giá quá hẹp): báo một dòng thay vì để nhóm trống trơn
            if (!g.none && !available) {
                g.none = document.createElement('p');
                g.none.className = 'filter-group__none';
                g.none.textContent = 'Không còn lựa chọn phù hợp';
                g.body.insertBefore(g.none, g.more || null);
            }
            if (g.none) g.none.hidden = available > 0;

            if (!g.more) return;
            g.more.hidden = g.expanded ? available <= g.limit : extra === 0;
            g.more.setAttribute('aria-expanded', g.expanded ? 'true' : 'false');
            if (g.moreLabel) g.moreLabel.textContent = g.expanded ? 'Thu gọn' : 'Xem thêm ' + extra + ' ' + g.noun;
        }

        // ----- Hàng tag: tag đang áp dụng (×) + gợi ý nhanh chưa áp dụng -----
        var pendingFocus = null;

        // Gợi ý nhanh bị ẩn khi đã áp dụng, HOẶC khi bấm vào sẽ ra 0 kết quả (vd. đang lọc
        // "Ý" thì gợi ý "Vang trắng" vô nghĩa) — cùng quy tắc "ẩn lựa chọn 0 kết quả" của sidebar
        function quickIsUseless(chip, state, products) {
            var target = chip.getAttribute('data-filter-quick');
            if (target === 'price') {
                var a = Number(chip.getAttribute('data-quick-min') || MIN);
                var b = Number(chip.getAttribute('data-quick-max') || MAX);
                if (state.lo === a && state.hi === b) return true;
                var next = { lists: state.lists, lo: a, hi: b, rating: state.rating };
                return !products.some(function (p) {
                    return matches(p, next, null);
                });
            }
            var option = optionById[target];
            if (!option) return true;
            return option.input.checked || option.count === 0;
        }

        function renderChips(state, active, products) {
            if (!chipsRow) return;
            if (activeBox) {
                activeBox.innerHTML = active.map(function (a) {
                    return '<button class="chip chip--removable" type="button" data-filter-remove="' + esc(a.id) + '">' +
                        '<span class="screen-reader-text">Bỏ lọc </span>' + esc(a.label) +
                        '<i class="ph-bold ph-x" aria-hidden="true"></i></button>';
                }).join('');
            }
            var quickLeft = 0;
            quickChips.forEach(function (chip) {
                chip.hidden = quickIsUseless(chip, state, products);
                if (!chip.hidden) quickLeft++;
            });
            if (chipsClear) chipsClear.hidden = !active.length;
            chipsRow.hidden = !active.length && !quickLeft;
        }

        // Nút vừa bấm biến mất (tag ×, gợi ý nhanh, "Xóa bộ lọc") thì đưa focus về chỗ gần
        // nhất còn hiện — không để focus rơi về <body> làm người dùng bàn phím lạc chỗ.
        function restoreFocus() {
            var want = pendingFocus;
            pendingFocus = null;
            if (!want) return;
            var candidates = [];
            if (want.id) candidates.push(chipsRow && chipsRow.querySelector('[data-filter-remove="' + want.id + '"]'));
            if (typeof want.index === 'number' && activeBox) {
                var chips = all('[data-filter-remove]', activeBox);
                candidates.push(chips[Math.min(want.index, chips.length - 1)]);
            }
            candidates = candidates.concat(quickChips, cards().map(function (card) {
                return card.querySelector('.product-card__title a');
            }));
            for (var i = 0; i < candidates.length; i++) {
                if (isShown(candidates[i])) {
                    candidates[i].focus();
                    return;
                }
            }
        }

        function renderResult(shown, state, active) {
            var list = cards();
            var total = parseInt(grid.getAttribute('data-total'), 10) || list.length;

            // "Hiển thị X trên Y": Y là tổng của danh mục (server), X là số card đang hiện
            if (resultEl) resultEl.textContent = 'Hiển thị ' + shown + ' trên ' + total + ' sản phẩm';

            if (submit) submit.textContent = shown ? 'Xem ' + shown + ' kết quả' : 'Không có kết quả';

            if (badge) {
                badge.textContent = String(active.length);
                badge.hidden = !active.length;
            }
            openers.forEach(function (button) {
                button.setAttribute('aria-label', active.length ? 'Bộ lọc, ' + active.length + ' đang áp dụng' : 'Bộ lọc');
            });

            grid.hidden = shown === 0;
            if (empty) empty.hidden = shown > 0;
            // Đang lọc thì kết quả đã đủ trên trang — "Xem thêm" chỉ có nghĩa với danh sách đầy đủ
            if (loadMore) loadMore.hidden = active.length > 0;
        }

        function apply() {
            var state = readState();
            var list = cards();
            var products = list.map(productOf);
            var shown = 0;

            list.forEach(function (card, i) {
                var ok = matches(products[i], state, null);
                card.hidden = !ok;
                if (ok) shown++;
            });

            groups.forEach(function (g) {
                g.options.forEach(function (o) {
                    o.count = 0;
                });
                products.forEach(function (p) {
                    if (!p || !matches(p, state, g.key)) return;
                    g.options.forEach(function (o) {
                        if (String(p[g.field]) === o.match) o.count++;
                    });
                });
                g.options.forEach(function (o) {
                    if (o.countEl) o.countEl.textContent = String(o.count);
                });
                layoutGroup(g);
            });

            var active = activeFilters(state);
            renderChips(state, active, products);
            renderResult(shown, state, active);
            restoreFocus();
        }

        // ----- Sắp xếp: dựng lại thứ tự card trong DOM -----
        function sortCards() {
            var mode = sortSelect ? sortSelect.value : 'popularity';
            var items = cards().map(function (card) {
                return { card: card, p: productOf(card) || {}, i: Number(card.getAttribute('data-shop-index')) };
            });
            items.sort(function (a, b) {
                var d = 0;
                if (mode === 'price') d = a.p.price - b.p.price;
                else if (mode === 'price-desc') d = b.p.price - a.p.price;
                else if (mode === 'date') d = (b.p.isNew ? 1 : 0) - (a.p.isNew ? 1 : 0);
                else if (mode === 'rating') d = (b.p.rating - a.p.rating) || (b.p.reviews - a.p.reviews);
                // Bằng nhau (hoặc thiếu dữ liệu → NaN) thì giữ thứ tự gốc cho ổn định
                return d || a.i - b.i;
            });
            items.forEach(function (item) {
                grid.appendChild(item.card);
            });
        }

        function clearAll() {
            groups.forEach(function (g) {
                g.options.forEach(function (o) {
                    o.input.checked = false;
                });
            });
            ratings.forEach(function (r) {
                r.checked = false;
            });
            markRatings();
            setRange(MIN, MAX);
        }

        // ----- Sự kiện -----
        document.addEventListener('click', function (event) {
            var target = event.target;
            if (!target.closest) return;

            var clear = target.closest('[data-filter-clear]');
            if (clear) {
                // Nút xoá trong hàng tag / khối 0 kết quả sẽ biến mất sau khi xoá
                if (clear !== form.querySelector('[data-filter-clear]')) pendingFocus = {};
                clearAll();
                apply();
                return;
            }

            var remove = target.closest('[data-filter-remove]');
            if (remove) {
                var id = remove.getAttribute('data-filter-remove');
                pendingFocus = { index: all('[data-filter-remove]', activeBox).indexOf(remove) };
                if (id === 'price') {
                    setRange(MIN, MAX);
                } else {
                    var input = document.getElementById(id);
                    if (input) input.checked = false;
                    markRatings();
                }
                apply();
                return;
            }

            var quick = target.closest('[data-filter-quick]');
            if (quick) {
                var key = quick.getAttribute('data-filter-quick');
                if (key === 'price') {
                    setRange(Number(quick.getAttribute('data-quick-min') || MIN), Number(quick.getAttribute('data-quick-max') || MAX));
                } else {
                    var box = document.getElementById(key);
                    if (box) box.checked = true;
                }
                pendingFocus = { id: key };
                apply();
            }
        });

        // Checkbox lọc ngay khi tick (desktop thấy lưới đổi tức thì; mobile thấy số trên nút cam)
        form.addEventListener('change', function (event) {
            var target = event.target;
            if (target.type === 'checkbox') apply();
            else if (target.type === 'radio') {
                markRatings();
                apply();
            } else if (target === loText) {
                commitText('lo');
                apply();
            } else if (target === hiText) {
                commitText('hi');
                apply();
            }
        });

        // Radio "Đánh giá" bấm lại lần nữa thì bỏ chọn — radio gốc không tự làm được,
        // mà guideline chỉ có hai mức, không có dòng "Tất cả" để thoát ra.
        function markRatings() {
            ratings.forEach(function (r) {
                r.setAttribute('data-was-checked', r.checked ? 'true' : 'false');
            });
        }

        ratings.forEach(function (radio) {
            radio.addEventListener('click', function () {
                if (radio.getAttribute('data-was-checked') === 'true') radio.checked = false;
                markRatings();
                apply();
            });
        });

        // Thanh trượt giá: kéo tới đâu lọc tới đó, gộp theo khung hình cho mượt
        var frame = 0;

        function onSlide(event) {
            var moved = event.target;
            var other = moved === lo ? hi : lo;
            if (moved === lo && Number(lo.value) > Number(hi.value) - STEP) lo.value = Number(hi.value) - STEP;
            if (moved === hi && Number(hi.value) < Number(lo.value) + STEP) hi.value = Number(lo.value) + STEP;
            moved.classList.add('is-top');
            other.classList.remove('is-top');
            paintRange();
            if (frame) return;
            frame = window.requestAnimationFrame(function () {
                frame = 0;
                apply();
            });
        }

        if (lo) {
            lo.addEventListener('input', onSlide);
            hi.addEventListener('input', onSlide);
            [loText, hiText].forEach(function (field) {
                // Chọn sẵn cả chuỗi để gõ đè, khỏi phải xoá "₫" và dấu chấm
                field.addEventListener('focus', function () {
                    field.select();
                });
            });
        }

        // Mở / thu gọn nhóm
        all('.filter-group__toggle', form).forEach(function (button) {
            button.addEventListener('click', function () {
                var body = document.getElementById(button.getAttribute('aria-controls'));
                var open = button.getAttribute('aria-expanded') !== 'true';
                button.setAttribute('aria-expanded', open ? 'true' : 'false');
                if (body) body.hidden = !open;
            });
        });

        groups.forEach(function (g) {
            if (!g.more) return;
            g.more.addEventListener('click', function () {
                g.expanded = !g.expanded;
                layoutGroup(g);
            });
        });

        // Enter trong ô giá hoặc bấm "Xem N kết quả": không tải lại trang (đã lọc tại chỗ).
        // Đóng drawer + cuộn về đầu danh sách là việc của shop-filter-drawer.js, nghe cùng sự kiện.
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (document.activeElement === loText) commitText('lo');
            if (document.activeElement === hiText) commitText('hi');
            apply();
        });

        if (sortSelect) {
            sortSelect.addEventListener('change', sortCards);
        }

        // shop-load-more.js nạp thêm card → đánh số, sắp xếp và đếm lại
        document.addEventListener('wb:shop-grid', function () {
            indexCards();
            sortCards();
            apply();
        });

        indexCards();
        markRatings();
        paintRange();
        // Trình duyệt có thể khôi phục lựa chọn cũ khi bấm Back
        if (sortSelect && sortSelect.value !== 'popularity') sortCards();
        apply();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
